'use strict';
const buildSvg = require('../widgets/build-svg'),
	localizeSVGImages = require('../models/localize-svg-images');
module.exports = function ThumbnailBuilder(config, contentRetriever, navigatorShim, pngConvertor, themeProvider, mapModel) {
	if (!config || !config.thumbnail || !config.thumbnail.scale || !config.thumbnail.width || !config.thumbnail.height) {
		throw 'invalid-args';
	}
	const self = this;
	self.build = function (/*options*/) {
		let url;
		return contentRetriever()
		.then((activeContent) => {
			const svgText = buildSvg(activeContent, themeProvider, {
				scale: config.thumbnail.scale,
				clipRect: {
					width: config.thumbnail.width,
					height: config.thumbnail.height
				},
				layout: mapModel && mapModel.getCurrentLayout()
			});
			return svgText;
		})
		.then((svgText) => localizeSVGImages(svgText, pngConvertor.convertToPng))
		.then((svgWithImages) => {
			url = navigatorShim.toObjectUrl(svgWithImages, 'image/svg+xml');
			return url;
		}).then(function (url) {
			return pngConvertor.convertToPng(url);
		}).then(function (pngUrl) {
			navigatorShim.revokeObjectUrl(url);
			return pngUrl;
		});
	};
};
